<div class="my-claims__head">
    <div class="my-claims__title">
        <h2>Meestgestelde vragen over schade</h2>
    </div>
</div>

<div class="my-claims__content my-claims__content--border">
    <ins-details-accordion icon="number">
        <ins-details-accordion-item>
            <div title>Hoe/waar kan ik mijn schade melden?</div>
            <div content>
                <p>
                    Heeft u schade? Wat vervelend! Bij acute noodsituaties, zoals een grote brand, overstroming, letsel
                    of diefstal van uw voertuig, belt u 24/7 met onze alarmcentrale op
                    <a href="tel:0031713641762">+31 (0)71 - 364 17 62</a>
                    . Alle schade zonder nood kunt u online melden. U kunt ons stapsgewijs uitleggen om wat voor schade
                    het gaat en wat er precies gebeurd is. Meer weten? Bekijk alles over online schademelden.
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>Wat zijn de gevolgen als ik schade meld?</div>
            <div content>
                <p>
                    Bij auto, motor- en brommerschade, kan uw premie omhoog gaan, omdat u meestal 5 schadevrije jaren
                    zakt op de bonusmaluladder en dus minder korting krijgt dan voordat u schade claimde. Voor sommige
                    verzekeringen betaalt u een (klein) deel van de schade zelf als Eigen Risico. U kunt heel makkelijk
                    uitrekenen wat u meer kost: de schade claimen of zelf laten repareren.
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>Hoe moet ik mijn schade laten vaststellen?</div>
            <div content>
                <p>
                    Heeft u schade aan uw auto en bent u daarvoor verzekerd? Dan kunt u de schade laten vaststellen bij
                    een vestiging van ABS Autoherstel. Tijdens het melden van uw schade kunt u hiervoor een afspraak
                    maken. Wilt u een afspraak wijzigen, belt u dan met de vestiging van ABS waar u een afspraak heeft
                    gemaakt (www.absautoherstel.nl).Voor het vaststellen van andere schades overlegt u met het
                    schadeteam. U kunt een e-mail sturen naar
                    <a href="mailto:schadeteam@inshared.nl">schadeteam&#64;inshared.nl</a>
                    of op werkdagen tussen 9 en 5 bellen op
                    <a href="tel:0031713641762">071 364 17 62</a>
                    .
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>Ik heb een schade gemeld, maar nog niets gehoord. Wat kan ik nu doen?</div>
            <div content>
                <p>
                    Dat is vervelend! Als u inlogt in uw digitale Verzekeringsmap, op 'Mijn schades' klikt en daarna uw
                    lopende schademelding opent, kunt u precies zien wat de status is van uw schadeafhandeling.
                    Misschien staan er nog actiepunten open, die u af moet handelen voordat we voor u aan de slag
                    kunnen? Bij uw schade vindt u ook uw Postvak, waarin u kunt nalezen wat er aan correspondentie is
                    verstuurd en binnengekomen. Kunt u niks vinden? Mail dan naar ons schadeteam&#64;inshared.nl of bel
                    op werkdagen tussen 09.00 - 17.00 uur op
                    <a href="tel:0031713641762">+31 (0)71 - 364 17 62 (nummer 4)</a>
                    . Dan zoeken we het graag verder voor u uit.
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>Ik wil documenten over mijn schade opsturen, waar kunnen ze naartoe?</div>
            <div content>
                <p>
                    U kunt de documenten uploaden in uw digitale Verzekeringsmap. Klik daarvoor links in het overzicht
                    op 'Mijn schades' en vervolgens op uw lopende schadeclaim. U mag ze natuurlijk ook scannen en dan
                    mailen naar schadeteam&#64;inshared.nl of per post versturen naar InShared schadeteam, Postbus
                    51090, 3007 GB, Rotterdam. Als u de documenten e-mailt, dan is het handig om grote/zware documenten
                    (meer dan 5MB) ‘op te knippen’. Vergeet u niet uw schadenummer in de onderwerpregel van uw e-mail te
                    vermelden?
                </p>
            </div>
        </ins-details-accordion-item>
    </ins-details-accordion>

    <div class="btn-group text-right">
        <a [href]="faqRoutingEnum.Schademelden" class="btn btn--more">Bekijk alle meestgestelde vragen</a>
    </div>

    <div class="h3">Contact opnemen</div>
    <p>
        Komt u er niet uit of kunt u geen informatie over uw lopende schade terugvinden, dan kunt u contact met ons
        opnemen
    </p>

    <div class="my-claims__button-container">
        <a
            class="btn btn--primary btn--primary-icon"
            [href]="contactQueryParams(AppRoutesEnum.Question, ContactCategoryEnum.Damage)"
        >
            <svg class="svg-icon svg-icon--s">
                <use href="assets/icons-general.svg#mail"></use>
            </svg>
            E-mail
        </a>

        <a class="btn btn--primary btn--primary-icon" href="tel:0031713641762">
            <svg class="svg-icon svg-icon--s">
                <use href="assets/icons-general.svg#telefoon"></use>
            </svg>
            Bellen
            <span class="btn--after">
                <svg class="svg-icon svg-icon--l">
                    <use href="assets/icons-general.svg#pijlRB"></use>
                </svg>
                <span class="btn--after-text-container">
                    <span>ma - vrij 9.00-17.00</span>
                    <span>Bel 071-36 417 62</span>
                </span>
            </span>
        </a>
    </div>
</div>

<div class="my-claims__head">
    <div class="my-claims__title">
        <h2>Wat zit er allemaal in de schademap?</h2>
    </div>
</div>
<div class="my-claims__content my-claims__content--border">
    <ins-details-accordion icon="check">
        <ins-details-accordion-item>
            <div title>De afspraken</div>
            <div content>
                <p>Welke afspraken heeft u? Ziehier uw online agenda  van afspraken met de herstellers.</p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>De stukken</div>
            <div content>
                <p>
                    Tijdens het schadeproces moet u soms documenten of foto’s uploaden. Die verzamelen we netjes in de
                    map.
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>De getuigen/betrokkenen</div>
            <div content>
                <p>Als er mensen bij de schade betrokken waren, vindt u hier een overzicht van.</p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>De actiepunten</div>
            <div content>
                <p>
                    Hebben we nog een actie van uw kant nodig om de schade af te kunnen handelen? Dan ziet u hier de to
                    do-lijst. Is alles afgerond? Dan staat dat er.
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>De post</div>
            <div content>
                <p>
                    Alle mails, brieven en andere communicatie die u bij andere verzekeraars niet te zien krijgt,
                    stoppen wij gewoon in uw schademap. Zo kunt u precies zien hoe de vlag erbij hangt.
                </p>
            </div>
        </ins-details-accordion-item>
    </ins-details-accordion>
</div>

<div class="my-claims__head">
    <div class="my-claims__title">
        <h2>Hoe handelen we schade af?</h2>
    </div>
</div>
<div class="my-claims__content my-claims__content--border">
    <ins-details-accordion icon="number">
        <ins-details-accordion-item>
            <div title>Bevestigen schademelding</div>
            <div content>
                <p>
                    Na het online schademelden, krijgt u meteen een mail van ons met een samenvatting van de schade. Die
                    bevestiging zetten we trouwens ook meteen in uw Postvak.
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>Vaststellen van de schade</div>
            <div content>
                <p>
                    De schade wordt vastgesteld door een expert of schadebehandelaar. Dit is afhankelijk van de type
                    schade die u heeft gehad.
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>Repareren/vergoeden</div>
            <div content>
                <p>
                    Zodra de hoogte van de schade bekend is, kunt u de schade repareren bij een aangesloten hersteller
                    zoals ABS Autoherstel, Autotaalglas, Carglass of HerstelDirect. Wilt u liever de schade bij uw eigen
                    hersteller laten maken, dan ontvangt u het schadebedrag binnen een paar dagen op uw rekening. Wist u
                    dat u korting op uw eigen risico ontvangt, wanneer u de schade laat repareren bij een aangesloten
                    hersteller?
                </p>
                <p>
                    Heeft de schade te maken met dier, reis of mensen? Dan storten we het bedrag dat u vergoed krijgt
                    (min een eventueel eigen risico) gewoon op uw rekening.
                </p>
            </div>
        </ins-details-accordion-item>
        <ins-details-accordion-item>
            <div title>Aansprakelijk stellen of Verhalen</div>
            <div content>
                <p>
                    Was de schade niet uw schuld? Dan nemen wij contact op met de andere verzekeraar of tegenpartij om
                    alles te regelen.
                </p>
            </div>
        </ins-details-accordion-item>
    </ins-details-accordion>
</div>

<ng-container *ngIf="items">
    <div class="my-claims__head">
        <h2>Met welke partners werken we samen?</h2>
    </div>
    <p>InShared werkt samen met een aantal goede, betrouwbare (herstel)bedrijven.</p>
    <ins-image-carousel [items]="items"></ins-image-carousel>
</ng-container>
